import axios from "axios";
import { useEffect, useState } from "react";

export default function ContractInfo(props) {
  const { sales } = props;

  const [contrInfoDataSource, setContrInfoDataSource] = useState(null);

  let AOSCount = 0;

  useEffect(async () => {
    if (sales.contrNo) {
      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/contrInfo/${sales.contrNo}`
      );

      setContrInfoDataSource(result.data);
    }
  }, [sales.contrNo]);

  return (
    <div className="tabpanel-item">
      <div>
        {sales.contrNo && (
          <table>
            <tbody>
              <tr>
                <th>Contract No.:</th>
                <td>
                  <b>{sales.contrNo}</b>
                </td>
                <th
                  style={{
                    paddingLeft: "60px",
                  }}
                >
                  Contract Date:
                </th>
                <td>
                  <b>
                    {contrInfoDataSource ? contrInfoDataSource.contrDate : ``}
                  </b>
                </td>
              </tr>
              <tr>
                <th
                  style={{
                    verticalAlign: "top",
                  }}
                >
                  Quotation No.:
                </th>
                <td colSpan={3}>
                  <table>
                    <tbody>
                      {contrInfoDataSource
                        ? contrInfoDataSource.quotNo.map(function (
                            quot,
                            index
                          ) {
                            return (
                              <tr>
                                <th>{quot.quotNo}</th>
                                <td>
                                  {quot.contrCat == "1" && quot.contrType == "1"
                                    ? "Initial Contract"
                                    : quot.contrCat == "1" &&
                                      quot.contrType == "2"
                                    ? "Amendment Contract"
                                    : "AOS-" + ++AOSCount}
                                </td>
                              </tr>
                            );
                          })
                        : ``}
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
